import { BubbleSort } from "./BubbleSort"
import { SelectionSort } from "./SelectionSort"
import { InsertionSort } from "./InsertionSort"
import MergeSort from "./MergeSort"

interface IAlgorithm {
    name: string
    value: string
    component?: React.ElementType
}

export const algorithms: IAlgorithm[] = [
    {
        name: "Bubble Sort",
        value: "bubbleSort",
        component: BubbleSort,
    },
    {
        name: "Selection Sort",
        component: SelectionSort,
        value: "selectionSort",
    },
    {
        name: "Insertion Sort",
        component: InsertionSort,
        value: "insertionSort",
    },
    {
        name: "Merge Sort",
        component: MergeSort,
        value: "mergeSort",
    },
    {
        name: "Quick Sort",
        component: undefined,
        value: "quickSort",
    },
    {
        name: "Quick Sort 3",
        component: undefined,
        value: "quickSort3",
    },
    {
        name: "Heap Sort",
        component: undefined,
        value: "heapSort",
    },
    {
        name: "Shell Sort",
        component: undefined,
        value: "shellSort",
    },
    {
        name: "Counting Sort",
        component: undefined,
        value: "countingSort",
    },
    {
        name: "Radix Sort",
        component: undefined,
        value: "radixSort",
    },
]
